/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line no-duplicate-imports
import type { TypedUseSelectorHook } from "react-redux";
import type { AppDispatch, RootState } from "./reduxStore";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
